// extracted by mini-css-extract-plugin
export default {"item":"style_item__kCOiy","image":"style_image__cr9Pv","content":"style_content__taunF"};